import { render, staticRenderFns } from "./CamujalSentTable.vue?vue&type=template&id=dc51e2d6&"
import script from "./CamujalSentTable.vue?vue&type=script&lang=js&"
export * from "./CamujalSentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports